import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useEffect, useState } from 'react';
import useIsMobile from '../hooks/useIsMobile';
import emailjs from '@emailjs/browser';

const bg = '#f0ebe3';
const red = '#6B1A1A';
const dark = '#4a1010';
const serif = 'Playfair Display, serif';
const body = 'Cormorant Garamond, serif';

function Contact() {
  const isMobile = useIsMobile();
  const [form, setForm] = useState({ from_name: '', business_name: '', phone: '', city: '', message: '' });
  const [status, setStatus] = useState('');

  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Cormorant+Garamond:wght@300;400&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (!form.from_name || !form.business_name || !form.phone) {
      setStatus('Please fill in all required fields.');
      return;
    }
    setStatus('Sending...');
    emailjs.send(
      'service_t1n2jua',
      'template_1dtgqks',
      { ...form, reply_to: form.phone },
      '8r9CSKmLcgS76ftqW'
    ).then(() => {
      setStatus('Message sent! We will get back to you within 24 hours.');
      setForm({ from_name: '', business_name: '', phone: '', city: '', service: '', message: '' });
    }).catch(() => {
      setStatus('Something went wrong. Please try again or call us directly.');
    });
  };

  const inputStyle = { backgroundColor: 'transparent', border: 'none', borderBottom: '0.5px solid #d4c9bc', padding: '12px 0', fontSize: '15px', fontFamily: body, color: '#2a1a1a', outline: 'none', width: '100%' };

  return (
    <div style={{ backgroundColor: bg, minHeight: '100vh', fontFamily: body, color: '#2a1a1a' }}>
      <Navbar />
      <div style={{ textAlign: 'center', padding: isMobile ? '40px 24px 20px' : '60px 40px 20px' }}>
        <p style={{ color: red, fontSize: '11px', letterSpacing: '4px', margin: '0 0 16px' }}>GET IN TOUCH</p>
        <h2 style={{ fontFamily: serif, fontSize: isMobile ? '36px' : '48px', fontWeight: '700', color: dark, margin: '0 0 16px', lineHeight: '1' }}>Contact</h2>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', margin: '20px 0' }}>
          <div style={{ height: '1px', width: '80px', backgroundColor: '#c9a882' }}></div>
          <div style={{ width: '6px', height: '6px', backgroundColor: '#c9a882', transform: 'rotate(45deg)' }}></div>
          <div style={{ height: '1px', width: '80px', backgroundColor: '#c9a882' }}></div>
        </div>
        <p style={{ fontSize: '16px', color: '#555', maxWidth: '500px', margin: '0 auto', lineHeight: '1.8', fontWeight: '300' }}>
          Ready to grow? Let's talk. We'll get back to you within 24 hours.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1px', backgroundColor: '#d4c9bc', margin: isMobile ? '30px 24px 60px' : '40px 60px 80px', border: '1px solid #d4c9bc' }}>
        <div style={{ backgroundColor: bg, padding: isMobile ? '30px 24px' : '60px' }}>
          <p style={{ color: red, fontSize: '10px', letterSpacing: '3px', margin: '0 0 24px' }}>REQUEST A CONSULTATION</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <input name="from_name" placeholder="Full Name" value={form.from_name} onChange={handleChange} style={inputStyle} />
            <input name="business_name" placeholder="Business Name" value={form.business_name} onChange={handleChange} style={inputStyle} />
            <input name="phone" placeholder="Phone Number" value={form.phone} onChange={handleChange} style={inputStyle} />
            <input name="city" placeholder="City / Service Area" value={form.city} onChange={handleChange} style={inputStyle} />
            <textarea name="message" placeholder="Tell us about your business..." rows="4" value={form.message} onChange={handleChange} style={{ ...inputStyle, resize: 'none' }} />
            {status ? <p style={{ color: status.includes('sent') ? 'green' : '#6B1A1A', fontSize: '13px', margin: 0 }}>{status}</p> : null}
            <button onClick={handleSubmit} style={{ backgroundColor: red, color: bg, padding: '18px', fontSize: '11px', letterSpacing: '3px', border: 'none', cursor: 'pointer', marginTop: '16px', fontFamily: body }}>
              REQUEST A CONSULTATION
            </button>
          </div>
        </div>

        <div style={{ backgroundColor: dark, padding: isMobile ? '30px 24px' : '60px' }}>
          <p style={{ color: '#c9a882', fontSize: '10px', letterSpacing: '3px', margin: '0 0 40px' }}>HERMES PARTNER CAPITAL</p>
          <h3 style={{ fontFamily: serif, fontSize: isMobile ? '26px' : '32px', fontWeight: '700', color: '#f0ebe3', margin: '0 0 24px', lineHeight: '1.3' }}>
  Let's build something<br />that works for<br />your business.
</h3>
<p style={{ fontSize: '15px', color: '#c9a882', lineHeight: '1.8', margin: '0 0 40px', fontWeight: '300' }}>
  We help local businesses grow with AI — smarter systems, faster follow-up, and more revenue without adding headcount. Tell us about your business and we'll take it from there.
</p>
          <div style={{ borderTop: '0.5px solid #4a3030', paddingTop: '40px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div>
              <p style={{ color: '#c9a882', fontSize: '10px', letterSpacing: '3px', margin: '0 0 4px' }}>EMAIL</p>
              <p style={{ color: '#f0ebe3', fontSize: '15px', margin: 0 }}>randy@hermespartnercapital.com</p>
            </div>
            <div>
              <p style={{ color: '#c9a882', fontSize: '10px', letterSpacing: '3px', margin: '0 0 4px' }}>PHONE</p>
              <p style={{ color: '#f0ebe3', fontSize: '15px', margin: 0 }}>(224) 475-9846</p>
            </div>
            <div>
              <p style={{ color: '#c9a882', fontSize: '10px', letterSpacing: '3px', margin: '0 0 4px' }}>LOCATION</p>
              <p style={{ color: '#f0ebe3', fontSize: '15px', margin: 0 }}>Chicagoland, Illinois</p>
            </div>
            <div>
              <p style={{ color: '#c9a882', fontSize: '10px', letterSpacing: '3px', margin: '0 0 4px' }}>WEBSITE</p>
              <p style={{ color: '#f0ebe3', fontSize: '15px', margin: 0 }}>hermespartnercapital.co</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;